import { render, staticRenderFns } from "./WorkflowTemplatesPage.vue?vue&type=template&id=ec21e4e6&scoped=true"
import script from "./WorkflowTemplatesPage.vue?vue&type=script&lang=js"
export * from "./WorkflowTemplatesPage.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTemplatesPage.vue?vue&type=style&index=0&id=ec21e4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec21e4e6",
  null
  
)

export default component.exports